<form>
    <div class="flex-direction-horizontal">
        <div class="flex-container-basic">
            <app-image srcPath="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? appService.defaultImageUri : this.itemEnvelope?.Document?.Item?.AvatarBlobPath }}" isApiImage="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? 'false' : 'true' }}" className="app-image-medium app-image-circle"></app-image>
        </div>
        <div class="flex-direction-vertical">
            <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Profile Name" [(ngModel)]="itemEnvelope.Document.Item.Name" />
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Gender</mat-label>
                <mat-select *ngIf="this.itemEnvelope" name="Gender" [(ngModel)]="this.itemEnvelope.Document.Item.GenderId">
                    <mat-option *ngFor="let gender of availableGenders" [value]="gender.GenderId">{{ gender.UID }}</mat-option>
                </mat-select>
            </mat-form-field>
            <span *ngIf="this.itemEnvelope">
                <mat-form-field class="input-narrow" appearance="outline">
                    <mat-label>Age Range (Lower)</mat-label>
                    <input matInput name="AgeRangeYearsLower" [(ngModel)]="this.itemEnvelope.Document.Item.AgeRangeYearsLower" />
                </mat-form-field>
                &nbsp;
                -
                &nbsp;
                <mat-form-field class="input-narrow" appearance="outline">
                    <mat-label>Age Range (Lower)</mat-label>
                    <input matInput name="AgeRangeYearsUpper" [(ngModel)]="this.itemEnvelope.Document.Item.AgeRangeYearsUpper" />
                </mat-form-field>
            </span>
        </div>
    </div>
    <br />
    <span>
        <app-chip-selector *ngIf="this.itemEnvelope" #ethnicitySelector label="Ethnicity" className="width-full" [isMultiSelect]="true" [availableItems]="availableEthnicities" [value]="selectedEthnicityIds"></app-chip-selector>
    </span>
    <br />
    <span>
        <app-chip-selector *ngIf="this.itemEnvelope" #characterTypeChipSelector label="Can Play" className="width-full" [isMultiSelect]="true" [availableItems]="availableCharacterTypes" [value]="selectedCharacterTypeIds"></app-chip-selector>
    </span>
    <br />
    <mat-form-field *ngIf="this.itemEnvelope" style="width: 100%;" appearance="outline">
        <mat-label>Pitch</mat-label>
        <textarea matInput name="Pitch" placeholder="(Enter pitch details)" [(ngModel)]="this.itemEnvelope.Document.Item.Pitch"></textarea>
    </mat-form-field>
</form>
